export default {
  name: 'CustomTabs',

  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      mainActiveTab: this.activeTab,
    };
  },

  computed: {
    getVisibleTabs() {
      return this.tabs.filter(tab => tab.isVisible);
    },
  },

  methods: {
    setActiveTabs(newActiveTab) {
      this.mainActiveTab = newActiveTab;
    },
  },
};
